import { autoinject, LogManager, bindable } from 'aurelia-framework';
import { HelpTopicRepository } from 'data/repository/help-topic-repository';
import { HelpTopic } from 'data/entities/entities';
import { EntityManager } from 'aurelia-orm';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { AppEvents } from 'core/app-events';
import { AppUserInfoService } from 'data/service/app-user-info-service';

@autoinject
export class HelpIcon {

	@bindable helpId: number;
	eventSubscriptions: Subscription[] = [];
	hideHelpSetting: boolean;

	constructor(
		private appUserInfoService: AppUserInfoService,
		private eventAggregator: EventAggregator) {
		
	}

	private unsubscribeFromEvents() {
		for (let entry of this.eventSubscriptions) {
			entry.dispose();
		}
		this.eventSubscriptions = [];
	}

	detached() {
		this.unsubscribeFromEvents();
	}

	subscribeToEvents(): any {
		
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.HideHelpSettingChanged, (hideHelpSetting:boolean) => {
			this.hideOrShowIcon(hideHelpSetting);
		}));
	}

	showIcon: boolean = false;

	hideOrShowIcon(hideHelpSetting:boolean) {
		this.showIcon = !hideHelpSetting;
	}

	async attached() {
		this.hideHelpSetting = await this.appUserInfoService.getHideHelpSetting();
		if (!this.hideHelpSetting) {
			this.showIcon = true;
		}
		
		this.subscribeToEvents();
	}

	showHelp() {
		this.showHelpItem(this.helpId);
	}

	showHelpItem(id: number) {
		this.eventAggregator.publish(AppEvents.ShowHelpItem, id);
	}
	

}